import { useTranslate } from "@similarweb/i18n-provider";

import { TableWidget } from "../../../common/widget/table/TableWidget";
import { useActivityAndAudienceData } from "../../hooks/useActivityAndAudienceData";

import type { ActivityAndAudienceRow } from "./types";
import { useActivityAndAudienceColumns } from "./useActivityAndAudienceColumns";

export const ActivityAndAudienceTable = () => {
    const { translate } = useTranslate();
    const { data, isLoading } = useActivityAndAudienceData();
    const columnsConfig = useActivityAndAudienceColumns();

    return (
        <TableWidget<ActivityAndAudienceRow>
            dataAutomation="social-activity-audience-card"
            columnConfig={columnsConfig}
            data={data}
            highlightedRowSelector={(record) => record.domain.isPrimary}
            isLoading={isLoading}
            title={translate("activation.alerts.social-media.metrics.activity-audience.title")}
        />
    );
};
